/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Main address of the subscriber (when available)
 * @export
 * @interface ContractInsuredAddress
 */
export interface ContractInsuredAddress {
    /**
     * 
     * @type {string}
     * @memberof ContractInsuredAddress
     */
    line1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractInsuredAddress
     */
    line2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractInsuredAddress
     */
    postalCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractInsuredAddress
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractInsuredAddress
     */
    country?: string | null;
}

/**
 * Check if a given object implements the ContractInsuredAddress interface.
 */
export function instanceOfContractInsuredAddress(value: object): value is ContractInsuredAddress {
    return true;
}

export function ContractInsuredAddressFromJSON(json: any): ContractInsuredAddress {
    return ContractInsuredAddressFromJSONTyped(json, false);
}

export function ContractInsuredAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractInsuredAddress {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
    };
}

export function ContractInsuredAddressToJSON(json: any): ContractInsuredAddress {
    return ContractInsuredAddressToJSONTyped(json, false);
}

export function ContractInsuredAddressToJSONTyped(value?: ContractInsuredAddress | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'country': value['country'],
    };
}

